import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import FactionMpProvider from "@/core/data-provider/data-mp/faction/faction-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";
import { QUERY_KEY_FACTION_GENERAL_INFO } from "@/domains/faction/hooks/useGetInfo";

type KnownErr = Error & { knownI18nKey?: boolean };

export function useUpgradeRank() {
  const { t, i18n } = useTranslation("faction");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await FactionMpProvider.upgradeRank();

      if (response instanceof RpcMpProviderSuccessResponse) {
        return;
      }

      const messageKey = response?.error?.message ?? "Unknown";
      const knownI18nKey = i18n.exists(`faction:faction.errors.${messageKey}`);
      const error = new Error(messageKey) as KnownErr;
      error.knownI18nKey = knownI18nKey;
      throw error;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: [QUERY_KEY_FACTION_GENERAL_INFO] });
    },
    onError: (err) => {
      const error = err as KnownErr;
      if (error.knownI18nKey) {
        toast.error(t(`faction.errors.${error.message}`));
      } else {
        toast.error(t("faction.toast.upgradeRankError"));
      }
    },
  });
}
